export let Navigate = {
	beforecomponents: [
		{
			title: "安装",
			titleEn: "install",
			path: "/guide/install"
		},
		{
			title: "快速上手",
			titleEn: "start",
			path: "/guide/start"
		}
	],
	components: [
		{
			title: "Basic",
			titleEn: "Basic",
			children: [
				{
					title: "按钮",
					titleEn: "Buttom",
					icon: "icon ion-social-youtube-outline",
					path: "/component/button"
				},
				{
					title: "分割按钮",
					titleEn: "SplitButton",
					icon: "icon ion-arrow-down-b",
					path: "/component/splitButton"
				},
				{
					title: "选择按钮",
					titleEn: "SelectButton",
					icon: "icon ion-android-more-horizontal",
					path: "/component/selectButton"
				}
			]
		},
		{
			title: "Form",
			titleEn: "Form",
			children: [
				{
					title: "单选按钮",
					titleEn: "RadioButton",
					icon: "icon ion-ios-circle-filled",
					path: "/component/radioButton"
				},
				{
					title: "下拉",
					titleEn: "DropDown",
					icon: "icon ion-chevron-down",
					path: "/component/dropdown"
				},
				{
					title: "混合输入框",
					titleEn: "InputGroup",
					icon: "icon ion-edit",
					path: "/component/inputgroup"
				},
				{
					title: "复选框",
					titleEn: "CheckBox",
					icon: "icon ion-android-checkbox-outline",
					path: "/component/checkbox"
				},
				{
					title: "开关",
					titleEn: "InputSwitch",
					icon: "icon ion-ios-toggle",
					path: "/component/switch"
				},
				{
					title: "密码",
					titleEn: "Password",
					icon: "icon ion-locked",
					path: "/component/password"
				},
				{
					title: "表格",
					titleEn: "Table",
					icon: "icon ion-ios-grid-view",
					path: "/component/table"
				},
				{
					title: "文件上传",
					titleEn: "FileUpload",
					icon: "icon ion-folder",
					path: "/component/fileupload"
				},
			]
		},
		{
			title: "View",
			titleEn: "View",
			children: [
				{
					title: "卡片",
					titleEn: "Card",
					icon: "icon ion-card",
					path: "/component/card"
				},
				{
					title: "切换卡",
					titleEn: "TabView",
					icon: "icon ion-ios-browsers-outline",
					path: "/component/tabs"
				},
				{
					title: "确认框",
					titleEn: "ConfirmDialog",
					icon: "icon ion-ios-albums-outline",
					path: "/component/confirm"
				},
				{
					title: "对话框",
					titleEn: "Dialog",
					icon: "icon ion-chatbubble-working",
					path: "/component/dialog"
				},
				{
					title: "侧边栏",
					titleEn: "Sidebar",
					icon: "icon ion-ios-pause",
					path: "/component/sidebar"
				},
				{
					title: "文字提示",
					titleEn: "Tooltip",
					icon: "icon ion-android-hangout",
					path: "/component/tooltip"
				},
				{
					title: "全局提示",
					titleEn: "Message",
					icon: "icon ion-android-textsms",
					path: "/component/messages"
				},
				{
					title: "覆盖提示",
					titleEn: "Growl",
					icon: "icon ion-android-chat",
					path: "/component/growl"
				}
			]
		},
		{
			title: "Navigation",
			titleEn: "Navigation",
			children: [
				{
					title: "步骤条",
					titleEn: "Steps",
					icon: "icon ion-ios-checkmark-outline",
					path: "/component/steps"
				},
				{
					title: "菜单",
					titleEn: "PanelMenu",
					icon: "icon ion-navicon-round",
					path: "/component/panelmenu"
				},
				{
					title: "面包屑",
					titleEn: "Breadcrumb",
					icon: "icon ion-ios-arrow-right",
					path: "/component/breadcrumb"
				}
			]
		}
	]
}


// WEBPACK FOOTER //
// ./src/app/config/navigate.ts